import { LandingPagesNavbar } from '@podus/ui';
import { useLanguage } from '@/i18n/LanguageContext';
import type { Language } from '@/i18n/translations';

export default function Navbar() {
    const { language, setLanguage, t, languages } = useLanguage();

    return (
        <LandingPagesNavbar
            labels={{
                home: t('nav.home'),
                services: t('nav.services'),
                help: t('nav.help'),
                signUp: t('nav.signUp'),
                login: t('nav.login'),
                signIn: t('nav.signIn'),
                getStarted: t('nav.getStarted'),
            }}
            language={{
                current: language,
                languages,
                onChange: (code: string) => setLanguage(code as Language),
            }}
        />
    );
}
